import { Box, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const ContentWrapper = Box.withConfig({
  width: '100%',
  justifyContent: 'center',
  padding: '$4',
  textAlign: 'center',
  alignItems: 'center',
  maxWidth: '500px',
  margin: 'auto',
});

export const ContentText = withTypography({ textAlign: 'center', mb: '$10' });

export const ContentHeader = Header.withConfig({
  textAlign: 'center',
  marginBottom: '$4',
});
